<template>
  <div>
    <section id="login-section" class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <figure class="logo">
              <img src="@/assets/logo_white.png" alt="logo" />
            </figure>
            <h3 class="title">Escuela del Arte Ecuestre de Chile</h3>
            <hr class="login-hr" />
            <p class="subtitle">Modificar contraseña</p>
            <div class="box">
              <p style="padding-bottom: 0.5rem">Ingresa una nueva contraseña y repítela para confirmar la actualización</p>
              <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="resetPassword">
                <ValidationProvider name="correo" rules="required|email" v-slot="{ errors }">
                  <b-field
                      :type="errors.length > 0 ? 'is-danger':''"
                      :message="errors[0]">
                      <b-input type="email"
                        v-model="email"
                        size="is-large"
                        placeholder="Correo"
                        disabled>
                      </b-input>
                  </b-field>
                </ValidationProvider>

                <ValidationProvider name="contraseña" rules="required" v-slot="{ errors }">
                  <b-field
                      :type="errors.length > 0 ? 'is-danger':''"
                      :message="errors[0]">
                      <b-input type="password"
                          v-model="password"
                          size="is-large"
                          password-reveal
                          placeholder="Contraseña">
                      </b-input>
                  </b-field>
                </ValidationProvider>

                <ValidationProvider name="confirmar contraseña" rules="required|confirmed:contraseña" v-slot="{ errors }">
                  <b-field
                    :type="errors.length > 0 ? 'is-danger':''"
                    :message="errors[0]">
                    <b-input type="password"
                             v-model="passwordConfirmation"
                             size="is-large"
                             password-reveal
                             placeholder="Confirmar Contraseña">
                    </b-input>
                  </b-field>
                </ValidationProvider>
                <!-- <div class="field">
                  <label class="checkbox">
                    <b-checkbox>Recuerdame</b-checkbox>
                  </label>
                </div> -->
                <b-button type="is-primary" size="is-large"
                  @click.prevent="resetPassword"
                  :loading="isLoading"
                  :disabled="invalid"
                  expanded>
                    Ingresar
                </b-button>
              </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import '@/scss/login.scss'

import AuthService from '@/services/AuthService.js'

export default {
  name: 'Login',
  data () {
    return {
      token: null,
      email: null,
      password: null,
      passwordConfirmation: null,
      remember: false,
      isLoading: false
    }
  },
  created () {
    this.token = this.$route.query.token
    this.email = this.$route.query.email ? this.$route.query.email : null
  },
  methods: {
    async resetPassword () {
      this.isLoading = true
      let result = await AuthService.passwordReset(this.token, this.email, this.password, this.passwordConfirmation)
      console.log(result.status)
      this.isLoading = false
      if (result.status === 200) {
        this.showDialogSuccess('Se ha actualizado la contraseña exitosaente')
        let url = await window.location.origin + '/#/login'
        setTimeout(async function () { window.location.href = url }, 2000)
      }
    },
    showDialog (text) {
      this.$buefy.toast.open({
        duration: 6000,
        message: text,
        position: 'is-bottom',
        type: 'is-danger'
      })
    },
    showDialogSuccess (text) {
      this.$buefy.toast.open({
        duration: 6000,
        message: text,
        position: 'is-bottom',
        type: 'is-success'
      })
    }
  }
}
</script>
